import { IProxyDictionaryApi } from '@/types';

export class ProxyDictionaryItem {
    id: number;
    ip?: string;
    isActive: 0 | 1;
    name: string;
    sites?: number[];

    constructor(data: IProxyDictionaryApi) {
        this.id = data.id;
        this.name = data.name ?? '';
        this.ip = data.ip;
        this.isActive = data.is_active;
        this.sites = data.sites === null ? data.sites : JSON.parse(data.sites);
    }

    includesSite(siteId: number): boolean {
        return this.sites === null || this.sites!.includes(Number(siteId));
    }

    isAvailableForSite(siteId: number): boolean {
        return this.isActive === 1 && this.includesSite(siteId);
    }
}
